import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./pgToast.css";

const TOAST_AUTO_CLOSE_MS = 5000;

const toastOptions = {
  position: "top-right",
  autoClose: TOAST_AUTO_CLOSE_MS,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  icon: false,
};

/**
 * Success / error / info toast (top-right, green bar + progress — no status icon).
 * @param {"success"|"error"|"info"} [variant]
 */
export function showPgToast(message, variant = "success") {
  if (!message) {
    return;
  }
  if (variant === "error") {
    toast.error(message, toastOptions);
    return;
  }
  if (variant === "info") {
    toast.info(message, toastOptions);
    return;
  }
  toast.success(message, toastOptions);
}

export function PgToastHost() {
  return (
    <ToastContainer
      className="pg-toast-container"
      toastClassName="pg-toast"
      bodyClassName="pg-toast__body"
      progressClassName="pg-toast__progress"
      closeButton={({ closeToast }) => (
        <button
          type="button"
          className="pg-toast__close"
          onClick={closeToast}
          aria-label="Close notification"
        >
          ×
        </button>
      )}
      newestOnTop
      limit={3}
    />
  );
}
